import { ITokenInfo } from "~/types/global"
import { axiosInstance } from "~/utils/axios"

export interface ITranscriptionStatusFile {
  file_id: string
  transcription_status: "pending" | "ready" | "failed" | null
}

export async function getTranscriptionStatus(
  tokenInfo: ITokenInfo,
  fileIds: string[]
) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/files/transcription_status`
  return await axiosInstance({
    method: "GET",
    url,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    params: { file_ids: fileIds.join(",") }
  })
}
